import { createFileRoute, notFound } from "@tanstack/react-router";
import { ErrorComponent } from "@/components/Error";
import { NotFound } from "@/components/NotFound";
import { Heading1 } from "@/components/Typography";
import { graphql } from "@/graphql";
import { apolloClient } from "@/lib/apollo-client";
import { removeNothings } from "@/lib/utils/arrays";
import { QuicksightDashboard } from "@/reports/QuicksightDashboard";

export const Route = createFileRoute("/(authed)/_layout/reports/$slug")({
  notFoundComponent: (props) => (
    <NotFound
      title="Report not found."
      message="The report you are looking for does not exist or you don't have access to it."
      backToPath="/reports"
      backToText="Back to reports"
      {...props}
    />
  ),
  errorComponent: (props) => (
    <ErrorComponent
      title="Report Error"
      message="There was a problem loading this report."
      backTo={{
        path: "/reports",
        text: "Back to reports",
      }}
      {...props}
    />
  ),
  component: ReportPage,
  loader: async ({ params }) => {
    const { slug } = params;
    const cattleSpeciesId = 3;

    const activeBusinessUnitId = localStorage.getItem("businessUnitId");

    if (!activeBusinessUnitId) {
      throw new Error("Failed to fetch report data. Missing business unit ID.");
    }

    const activeBusinessUnitIdInt = Number(activeBusinessUnitId);

    if (activeBusinessUnitIdInt > 0 === false) {
      throw new Error("Failed to fetch report data. Invalid business unit ID.");
    }

    const { data } = await apolloClient.query({
      query: getBaseReportsDataQuery,
      variables: {
        businessUnit: activeBusinessUnitIdInt,
        species: cattleSpeciesId,
        frontend: "SUPPLY_CHAINS",
      },
    });

    const reports = removeNothings(data.reports || []);
    const report = reports.find((r) => r.slug === slug);

    if (!report) {
      throw notFound();
    }

    return {
      report: {
        id: report.id,
        title: report.title,
      },
      crumb: report.title,
    };
  },
});

function ReportPage() {
  const { report } = Route.useLoaderData();

  return (
    <div className="container mx-auto p-6">
      <div className="space-y-6">
        <Heading1>{report.title}</Heading1>

        <div className="w-full">
          <QuicksightDashboard reportId={report.id} />
        </div>
      </div>
    </div>
  );
}

const getBaseReportsDataQuery = graphql(`
  query BaseReportsData($businessUnit: Int, $species: Int, $frontend: ReportFrontendEnum) {
    reports(businessUnit: $businessUnit, species: $species, frontend: $frontend) {
      id
      title
      slug
    }
  }
`);
